import React, { Component } from 'react';

class VideoModal extends Component {
  
  render(){

    return(
      <div className="modal-overlay dark show">
        <div className="modal-container modal-medium show" id="modal1">
            <div className="modal-header">
                <h3 className="no-margin">{this.props.video.title}</h3>
                <a className="modal close" href="/" onClick={this.props.handleClose}><i className="fa fa-times fa-lg" aria-hidden="true"></i></a>
            </div>
            <div className="modal-content">
                <iframe frameBorder="0" className="video" src={`${this.props.video.link}?autoplay=1`}>

                </iframe>
                

            </div>
        </div>
    </div>
    );
  }
}
export default VideoModal;


// WEBPACK FOOTER //
// ./src/modules/pieces/VideoModal.js